import { IconProps } from '@/shared/types/icon';
import { IconFont } from '../IconFont/components/organisms/IconFont';
import type { IconFontSize, IconFontColor, AnyIconDefinition } from '@/shared/types/types';
export function Icon({
  name,
  size = 'sm',
  color = 'current',
  className,
  background = false,
  backgroundColor,
  backgroundSize = 'md',
  padding = 'none',
  style,
  onClick,
  colorDuotonePrimary,
  colorDuotoneSecondary,
  opacityDuotonePrimary,
  opacityDuotoneSecondary,
}: IconProps) {
  return (
    <IconFont
      style={style}
      className={className}
      icon={name as unknown as AnyIconDefinition}
      size={size as IconFontSize}
      color={color as IconFontColor}
      colorDuotonePrimary={colorDuotonePrimary}
      colorDuotoneSecondary={colorDuotoneSecondary}
      opacityDuotonePrimary={opacityDuotonePrimary}
      opacityDuotoneSecondary={opacityDuotoneSecondary}
      background={background}
      backgroundColor={backgroundColor}
      backgroundSize={backgroundSize}
      padding={padding}
      onClick={onClick}
    />
  );
}
